/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/filter_builder.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { filterBuilderModule } from "../../../grids/grid_core/filter/m_filter_builder";
import core from "../m_core";
core.registerModule("filterBuilder", filterBuilderModule);